import { useGetEmployeeOverviewQuery } from '@app/main/api';
import { Spin } from 'antd';
import { EmployeeOverviewContent } from '@app/main/components';
import { RtkqSpin } from '@app/base';

export interface EmployeeOverviewPanelProps {
  id: string;
  className?: string;
}

export function EmployeeOverviewPanel(props: EmployeeOverviewPanelProps) {
  const { id, className } = props;

  const { data: employee } = useGetEmployeeOverviewQuery({ id, [RtkqSpin]: false });

  if (!employee)
    return (
      <div className="w-full text-center my-5">
        <Spin />
      </div>
    );

  return <EmployeeOverviewContent className={className} employee={employee} compact={false} />;
}
